export default {
  REGISTER_STANDARD: 'standard',
  REGISTER_GOOGLE: 'google',
  REGISTER_FACEBOOK: 'facebook',
  REGISTER_LINE: 'line',

  // 收藏類型
  FAVORITE_TYPE_SERIES: 'series',
  FAVORITE_TYPE_NEWS: 'news',

  //客服紀錄服務類型
  CUSTOMER_SERVICE_TYPE_NORMAL: 'normal', //一般服務
  CUSTOMER_SERVICE_TYPE_SATELLITE: 'satellite', //衛星問題
  CUSTOMER_SERVICE_TYPE_NETWORK: 'network', //網路問題
  CUSTOMER_SERVICE_TYPE_PROGRAM: 'program', //節目製播

  //客服紀錄問題性質
  CUSTOMER_PROBLEM_TYPE_ASK: 'ask', //詢問
  CUSTOMER_PROBLEM_TYPE_SUPPORT: 'support', //支持
  CUSTOMER_PROBLEM_TYPE_PRAISE: 'praise', //讚美
  CUSTOMER_PROBLEM_TYPE_COMPLAIN: 'complain', //抱怨
  CUSTOMER_PROBLEM_TYPE_CRITICISM: 'criticism', //批評
  CUSTOMER_PROBLEM_TYPE_RECOMMEND: 'recommend', //建議

  // 客服狀態
  CUSTOMER_SERVICE_STATUS_PENDING: 'pending', // 未處理
  CUSTOMER_SERVICE_STATUS_PROCESSING: 'processing', // 處理中
  CUSTOMER_SERVICE_STATUS_PROCESSED: 'processed', // 已處理

  //客服紀錄問題所屬單位
  CUSTOMER_SERVICE_DEPARTMENT_PROJECT: 'project', //工程部
  CUSTOMER_SERVICE_DEPARTMENT_ADMIN: 'admin', //行政室
  CUSTOMER_SERVICE_DEPARTMENT_PROGRAM: 'program', //節目部
  CUSTOMER_SERVICE_DEPARTMENT_NEWS: 'news', //新聞部
  CUSTOMER_SERVICE_DEPARTMENT_MARKETING: 'marketing', //行銷企劃部

  //客服紀錄服務項目
  CUSTOMER_SERVICE_ITEM_PROGRAM: 'program', //節目內容
  CUSTOMER_SERVICE_ITEM_SCHEDULE: 'schedule', //節目排檔
  CUSTOMER_SERVICE_ITEM_NETWORK: 'network', //網路資訊
  CUSTOMER_SERVICE_ITEM_MARKETING: 'marketing', // 行銷活動
  CUSTOMER_SERVICE_ITEM_DUBBING: 'dubbing', //配音發音
  CUSTOMER_SERVICE_ITEM_WATCH: 'watch', //收視問題
  CUSTOMER_SERVICE_ITEM_OTHER: 'other', //其他服務

  //客服紀錄意見來源
  CUSTOMER_PROBLEM_SOURCE_CUSTOM: 'custom', //專人接聽
  CUSTOMER_PROBLEM_SOURCE_POST: 'post', //郵寄信函
  CUSTOMER_PROBLEM_SOURCE_FAX: 'fax', //傳真
  CUSTOMER_PROBLEM_SOURCE_ONLINE: 'online', //線上客服
  CUSTOMER_PROBLEM_SOURCE_EMAIL: 'email', //電子郵件
  CUSTOMER_PROBLEM_SOURCE_GROUP: 'group', //社群
  CUSTOMER_PROBLEM_SOURCE_SITE: 'site', //現場詢問

  //客服紀錄回覆時間
  CUSTOMER_PROBLEM_REPLY_TIME_SITE:  'site', //現場回覆
  CUSTOMER_PROBLEM_REPLY_TIME_LESS_ONE:  'less_one', //1天內
  CUSTOMER_PROBLEM_REPLY_TIME_ONE:  'one', //1天
  CUSTOMER_PROBLEM_REPLY_TIME_TWO:  'two', //2天
  CUSTOMER_PROBLEM_REPLY_TIME_THREE:  'three', //3天
  CUSTOMER_PROBLEM_REPLY_TIME_OVER_THREE:  'over_three', //超過3天

  REPRESENTATION_STATUS_PENDING: 'pending', // 未處理
  REPRESENTATION_STATUS_PROCESSING: 'processed', // 已處理

  //參訪團隊類型
  VISIT_GROUP_TYPE_幼兒: '幼兒園/托兒所',
  VISIT_GROUP_TYPE_安親班: '安親班',
  VISIT_GROUP_TYPE_國小: '國小',
  VISIT_GROUP_TYPE_國中: '國中',
  VISIT_GROUP_TYPE_高中: '高中',
  VISIT_GROUP_TYPE_大專院校: '大專院校',
  VISIT_GROUP_TYPE_社會團體: '社會團體',
  VISIT_GROUP_TYPE_營隊: '營隊',
  VISIT_GROUP_TYPE_其他: '其他',

  // 參訪狀態
  VISIT_STATUS_PENDING: 'pending', // 未處理
  VISIT_STATUS_APPLY: 'apply', // 核准
  VISIT_STATUS_REJECT: 'reject', // 拒絕

  // 參訪開放狀態
  VISIT_TIME_PERIOD_MORNING: 'morning', // 上午
  VISIT_TIME_PERIOD_AFTERNOON: 'afternoon', // 下午
  VISIT_TIME_PERIOD_CLOSE: 'close', // 全面關閉
  VISIT_TIME_PERIOD_ALL_DAY: 'all-day', // 全天開放

  //推播狀態
  PUSH_TYPE_NOW: 'now', // 立即發布
  PUSH_TYPE_JOB: 'job', // 排程
  PUSH_TYPE_DRAFT: 'draft', // 草稿

  //會員通知類型
  NOTICE_TYPE_PUSH:'push', // 推播
  NOTICE_TYPE_ORDER_PROCESSING: 'order_processing', // 訂單處理中
  NOTICE_TYPE_ORDER_PROCESSED: 'order_processed', // 訂單已處理
  NOTICE_TYPE_CUSTOMER_PROCESSING: 'customer_processing', // 客服訊息處理中
  NOTICE_TYPE_CUSTOMER_PROCESSED: 'customer_processed', // 客服訊息已處理
  NOTICE_TYPE_CUSTOMER_PENDING: 'customer_pending', // 客服訊息已送出
  NOTICE_TYPE_REPRESENTATION_PROCESSED: 'representation_processed', // 申訴訊息已處理
  NOTICE_TYPE_VISIT_APPLY: 'visit_apply', // 參訪申請核准
  NOTICE_TYPE_VISIT_REJECT: 'visit_reject', // 參訪申請拒絕
  NOTICE_TYPE_ORDER: 'order',
  NOTICE_TYPE_CUSTOMER: 'customer',
  NOTICE_TYPE_REPRESENTATION: 'representation',
  NOTICE_TYPE_VISIT: 'visit',



}